//@ts-nocheck
export const isEnterKeyPress = (event): boolean => {
  const ENTER_KEY_CODE = 13
  return (
    event.key === 'Enter' ||
    event.which === ENTER_KEY_CODE ||
    event.keyCode === ENTER_KEY_CODE
  )
}
